import { Row, Col, Card, Form, Input, Checkbox, Icon } from 'antd';
import { signature } from './formConfig';
import { ssFormUtils, ssFormValidationUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const
config = signature,
{ key } = config,
{ generateFormItem, generateInputComponent } = ssFormUtils,
{ validateForm, validateSubForm } = ssFormValidationUtils;

export default class Signature extends React.Component {
    state = { isValid: false }
    constructor(props) { super(props); }

    componentDidUpdate(prevProps) {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        prevForm = prevProps.registrationForm[key],
        { storeForm } = services;

        if(!ssCommonUtils.simpleObjectCompare(prevForm, form)) {
            const formState = validateForm(form, config, true);
            storeForm(key, formState);
            this.setState({ isValid: validateSubForm(formState) });
        }
    }

    setMaxWidth = d => ({...d, style: { width: '100%' }});

    render() {
        const
        { services, registrationForm } = this.props,
        form = registrationForm[key],
        { storeForm, storeFormField } = services;

        return (
            <div>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={12}>
                        <Card hoverable style={{ marginBottom: '25px', cursor: 'default' }} bodyStyle={{ padding: '10px' }}>
                            <span style={{ fontWeight: 'bold', lineHeight: '18px' }}>
                                <Icon type='info-circle-o' style={{ fontWeight: 'bold', marginRight: '6px' }} />
                                <a href={ssCommonUtils.setEnvPrefix("/home/warning?url=") + encodeURIComponent('https://www.justice.gov/jm/criminal-resource-manual-903-false-statements-concealment-18-usc-1001')}>{'Title 18 Section 1001'}</a>
                                {' of the U.S. Code provides that knowingly falsifying or concealing a '}
                                {'material fact is a felony that may result in fines of up to $10,000 or 5 years in prison '}
                                {'or both. By submitting this form, you are certifying that the information provided herein '}
                                {'is true and complete to the best of your knowledge and ability.'}
                            </span>
                        </Card>
                        <Card hoverable style={{ marginBottom: '35px', cursor: 'default' }} bodyStyle={{ padding: '10px' }}>
                        <Icon type='info-circle-o' style={{ fontWeight: 'bold', marginRight: '6px' }} />
                            <span style={{ fontWeight: 'bold', lineHeight: '18px' }}>
                                {'I hereby declare under penalty of perjury that the information contained on this form is true and correct.'}
                            </span>
                        </Card>
                    </Col>
                </Row>
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={12}>
                        <Form>
                            <Row type='flex' justify='space-around' align='middle' gutter={10} style={{fontWeight: 'bold'}}>
                                <Col span={12}>
                                    <Form.Item {...generateFormItem("agree", config, form)}>
                                        <Checkbox {...this.setMaxWidth(generateInputComponent("agree", config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item {...generateFormItem("fullName", config, form)}>
                                        <Input {...this.setMaxWidth(generateInputComponent("fullName", config, true, form, storeFormField, storeForm))}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </div>
        )
    }
}
